import React from 'react';

import type { CheckboxInputProps } from '../CheckboxInput/CheckboxInput';
import type { LabelProps } from '../Label/Label';
import { CheckboxInput } from '../CheckboxInput/CheckboxInput';
import { Label } from '../Label/Label';

export interface CheckboxInputWithLabelProps extends CheckboxInputProps, LabelProps {
  children: React.ReactNode;
}

export function CheckboxInputWithLabel({
  'aria-label': ariaLabel,
  checked = false,
  children,
  disabled = false,
  id,
  indeterminate = false,
  invalid,
  name,
  onChange,
}: CheckboxInputWithLabelProps) {
  return (
    <Label disabled={disabled} invalid={invalid} aria-label={ariaLabel}>
      <CheckboxInput
        id={id}
        name={name}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        indeterminate={indeterminate}
      />
      {children}
    </Label>
  );
}
